export default __webpack_public_path__ + "static/media/praym.b5a3b93f.png";